<template>
  <footer class="footer">
    <nav class="footer__nav">
      <router-link :to="{ name: 'member_terms' }" class="footer__nav__link">{{ getWords("footer_privacy") }}</router-link>
    </nav>
    <section class="footer__logo">
      <img src="../assets/images/background_gray_brain.svg" alt="">
      <p>{{ getWords("footer_title") }}</p>
      <p>Quick-BHQ</p>
    </section>
  </footer>
</template>

<script>
import words from '../assets/localewords.json'
export default {
  name: 'MedicalFooterItem',
  computed: {
    getLanguage () {
      return this.$store.state.language
    }
  },
  methods: {
    getWords (key) {
      let lang = this.getLanguage
      const word = words[key] ? words[key][lang] : ''
      return word
    }
  }
}
</script>

<style scoped lang="scss">
@use "../assets/scss/style" as g;
.footer {
  padding: 2.9rem 0 2rem;
  text-align: center;
  background: g.$black;
  &__nav {
    margin: 0 0 2.1rem;
    &__link {
      display: inline-block;
      font-size: 1.2rem;
      text-decoration: underline;
      color: g.$baseColor;
      margin: 0 .8rem;
      vertical-align: middle;
    }
  }
  &__logo {
    font-size: 1.2rem;
    color: #676767;
    img {
      margin: 0 0 1.1rem;
    }
    p {
      line-height: line_height(12, 18);
    }
  }
}
</style>
